<template>
  <div>
    <header-bar>登録情報</header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">アカウント情報 - 退会</h3>
      </div>
      <div class="page-block__inner">
        <div class="profile_change_settlement-area">
          <div class="withdrawal-head-text">
            退会すると以下の収益は失効します。
            <p v-if="isSubscriber">
              ※退会にはサブスクプランの解約が必要です。
            </p>
          </div>
        </div>
      </div>
      <div class="payment-block__inner">
        <div class="payment-about">
          <balance-report></balance-report>
          <div class="payment-about__block">
            <div class="payment-about__text">
              最低お支払い金額は1,000円からとなります。<br>
              ご自身で「支払い申請」を行う必要があります。<br>
              振込は「支払い申請」を行った月の翌月末日に行います。<br>
            </div>
            <br>
            <div class="payment-about__text--caution">
              ※翌月末日が銀行休業日の場合は、前営業日となります。<br>
              ※振込手数料は一律330円差し引かせていただきます。
            </div>
          </div>
        </div>
        <div
          v-if="isSubscriber"
          class="c-btn-wrap pcmt40">
          <router-link
            :to="{ name: 'subscription-cancellation' }"
            class="c-btn">
            サブスクプラン契約解除へ
            <span class="c-btn__icon-arrow"></span>
          </router-link>
          <router-link
            :to="{ name: 'profile' }"
            class="c-btn c-btn--back c-btn--back-left">
            戻る<span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </router-link>
        </div>
      </div>
      <div class="page-block__inner">
        <alert-view
          title="確認事項・アンケートのご入力内容をご確認ください"
          :errors="validated_errors" />
        <form class="form--error">
          <div
            :class="[{'disabled': isSubscriber},'withdrawal-form']">
            <p class="withdrawal-form-text pcmb30 spmb30">
              確認事項をお読みいただき、ご確認・同意の上、チェックボックスにチェックを入れてください。<br>
              ご同意いただけない場合は退会できません。
            </p>
            <div class="withdrawal-form-wrap">
              <div
                v-for="(item, i) in answers.check_list"
                :key="'check' + i"
                class="checkbox">
                <label>
                  <input
                    v-model="item.value"
                    type="checkbox">
                  <div class="option-input"></div>
                  {{ item.text }}
                </label>
              </div>
            </div>
            <p
              v-if="errors.error1.value"
              class="error-text">
              確認事項にご同意いただけない場合は退会できません。
            </p>
            <p class="withdrawal-form-text pcmt50 spmt50">退会前に下記アンケートにご回答お願いいたします。</p>
            <p class="withdrawal-form-title">本サービス(narasu)を知ったきっかけは何ですか？</p>
            <div class="withdrawal-form-wrap">
              <div class="radio">
                <label>
                  <input
                    v-model="answers.a1"
                    type="radio"
                    name="a1"
                    value="インターネット広告">
                  <div class="option-input"></div> インターネット広告
                </label>
              </div>
              <div class="radio">
                <label>
                  <input
                    v-model="answers.a1"
                    type="radio"
                    name="a1"
                    value="知人から紹介">
                  <div class="option-input"></div> 知人から紹介
                </label>
              </div>
              <div class="radio">
                <label>
                  <input
                    v-model="answers.a1"
                    type="radio"
                    name="a1"
                    value="検索エンジン">
                  <div class="option-input"></div> 検索エンジン
                </label>
              </div>
              <div class="radio">
                <label>
                  <input
                    v-model="answers.a1"
                    type="radio"
                    name="a1"
                    value="SNS">
                  <div class="option-input"></div> SNS
                </label>
              </div>
              <div class="radio">
                <label>
                  <input
                    v-model="answers.a1"
                    type="radio"
                    name="a1"
                    value="5">
                  <div class="option-input"></div> その他（フリーテキスト）
                </label>
              </div>
              <textarea
                v-model="answers.a1_5"
                class="form-control form-control-other"
                rows="5"></textarea>
              <p
                v-if="errors.error2.value"
                class="error-text">
                選択してください
              </p>
              <p
                v-if="errors.error3.value"
                class="error-text">
                「その他」の内容をご入力ください
              </p>
            </div>
            <p class="withdrawal-form-title">narasuのサービスはいかがでしたでしょうか？</p>
            <div class="withdrawal-form-wrap withdrawal-form-wrap--inline">
              <div class="radio">
                <label>
                  <input
                    v-model="answers.a2"
                    type="radio"
                    name="a2"
                    value="よくない">
                  <div class="option-input"></div> よくない
                </label>
              </div>
              <div class="radio">
                <label>
                  <input
                    v-model="answers.a2"
                    type="radio"
                    name="a2"
                    value="あまりよくない">
                  <div class="option-input"></div> あまりよくない
                </label>
              </div>
              <div class="radio">
                <label>
                  <input
                    v-model="answers.a2"
                    type="radio"
                    name="a2"
                    value="ふつう">
                  <div class="option-input"></div> ふつう
                </label>
              </div>
              <div class="radio">
                <label>
                  <input
                    v-model="answers.a2"
                    type="radio"
                    name="a2"
                    value="よかった">
                  <div class="option-input"></div> よかった
                </label>
              </div>
              <div class="radio">
                <label>
                  <input
                    v-model="answers.a2"
                    type="radio"
                    name="a2"
                    value="とてもよかった">
                  <div class="option-input"></div> とてもよかった
                </label>
              </div>
            </div>
            <p
              v-if="errors.error4.value"
              class="error-text">
              選択してください
            </p>
            <p class="withdrawal-form-title">退会理由</p>
            <div class="withdrawal-form-wrap">
              <div class="checkbox">
                <label>
                  <input
                    v-model="answers.a3"
                    type="checkbox"
                    name="a3"
                    value="音楽が聴けるサービスと思い間違って登録したから">
                  <div class="option-input"></div> 音楽が聴けるサービスと思い間違って登録したから
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    v-model="answers.a3"
                    type="checkbox"
                    name="a3"
                    value="2">
                  <div class="option-input"></div> 楽曲の登録が難しいから
                </label>
              </div>
              <div
                v-if="hasDifficult"
                class="pcmt10 spmt10 pcml30 spml30">
                <div
                  v-for="(option, index) in options1"
                  :key="index"
                  class="checkbox">
                  <label>
                    <input
                      v-model="answers.a3_2"
                      type="checkbox"
                      name="a3_2"
                      :value="`${option}`">
                    <div class="option-input"></div> {{ option }}
                  </label>
                </div>
                <p
                  v-if="errors.error8.value"
                  class="error-text">
                  選択してください
                </p>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    v-model="answers.a3"
                    type="checkbox"
                    name="a7"
                    value="収益が少ないから">
                  <div class="option-input"></div> 収益が少ないから
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    v-model="answers.a3"
                    type="checkbox"
                    name="a3"
                    value="1">
                  <div class="option-input"></div> 他のサービスを利用するから
                </label>
              </div>
              <div
                v-if="hasOtherService"
                class="c-select_wrap pcmt10 spmt10">
                <select
                  v-model="answers.a3_1"
                  class="form-control c-select"
                  name="language">
                  <option
                    value=""
                    disabled
                    selected
                    style="display:none;">
                    選択してください
                  </option>
                  <option
                    v-for="(service,i) in other_services"
                    :key="i"
                    :value="'他のサービスを利用するから:'+service">
                    {{ service }}
                  </option>
                </select>
              </div>
              <input
                v-if="answers.a3.includes('1') && answers.a3_1=='他のサービスを利用するから:その他'"
                v-model="answers.a3_1_1"
                placeholder="利用するサービスをご入力ください"
                type="text"
                class="form-control form-control-other" />
              <p
                v-if="errors.error5.value"
                class="error-text">
                サービスを選択してください
              </p>
              <p
                v-if="errors.error11.value"
                class="error-text">
                {{ errors.error11.text }}
              </p>
              <div class="checkbox">
                <label>
                  <input
                    v-model="answers.a3"
                    type="checkbox"
                    name="a3"
                    value="音楽活動をやめるから">
                  <div class="option-input"></div> 音楽活動をやめるから
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    v-model="answers.a3"
                    type="checkbox"
                    name="a3"
                    value="5">
                  <div class="option-input"></div> 使いにくかったから
                </label>
              </div>
              <textarea
                v-if="answers.a3.includes('5')"
                v-model="answers.a3_5"
                class="form-control form-control-other"
                rows="5"></textarea>
              <p
                v-if="errors.error9.value"
                class="error-text">
                {{ errors.error9.text }}
              </p>
              <div class="checkbox">
                <label>
                  <input
                    v-model="answers.a3"
                    type="checkbox"
                    name="a3"
                    value="6">
                  <div class="option-input"></div> 欲しい機能が不足している
                </label>
              </div>
              <textarea
                v-if="answers.a3.includes('6')"
                v-model="answers.a3_6"
                class="form-control form-control-other"
                rows="5"></textarea>
              <p
                v-if="errors.error10.value"
                class="error-text">
                {{ errors.error10.text }}
              </p>
              <div class="checkbox">
                <label>
                  <input
                    v-model="answers.a3"
                    type="checkbox"
                    name="a3"
                    value="4">
                  <div class="option-input"></div> その他
                </label>
              </div>
              <textarea
                v-model="answers.a3_4"
                class="form-control form-control-other"
                rows="5"></textarea>
              <p
                v-if="errors.error6.value"
                class="error-text">
                ひとつ以上選択してください
              </p>
              <p
                v-if="errors.error7.value"
                class="error-text">
                「その他」の内容をご入力ください
              </p>
            </div>
            <div class="c-btn-wrap">
              <a
                class="c-btn"
                @click.prevent="onClickWithdrawal">
                退会する<span class="c-btn__icon-arrow"></span>
              </a>
              <router-link
                :to="{ name: 'profile' }"
                class="c-btn c-btn--back c-btn--back-left">
                戻る<span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
              </router-link>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'
import BalanceReport from '../Top/Dashboard/BalanceReport'
import AlertView from '../AlertView'

export default {
  components: {
    HeaderBar,
    BalanceReport,
    AlertView,
  },
  props: {
    options1: {
      type: Array,
      default: () => ([
        '入力する内容が多すぎる',
        'ジャケット写真などが画像アップロードが難しい',
        'ジャケット写真、音源データなどのルールが厳しい',
        'スマートフォンからだと入力しずらい',
        '入力方法がわからない',
      ]),
    },
  },
  data() {
    return {
      other_services: ['TuneCore Japan', 'BIG UP!', 'Eggs Pass', 'FRIENDSHIP.', 'sprayer', 'ROUTER.FM', 'その他'],
      answers: {
        check_list: [
          {
            text: '退会された場合、収益は失効いたします。',
            value: false,
          },
          {
            text: '退会された場合、いかなる理由があっても退会の取り消しはできません。',
            value: false,
          },
          {
            text: '1000円未満の収益については全て失効いたします。',
            value: false,
          },
          {
            text: '退会された場合、登録済みの楽曲は全配信サイトで全て配信停止となります。',
            value: false,
          },
          {
            text: '退会後に発生する収益については、お支払いすることはできません。',
            value: false,
          },
        ],
        a1: null,
        a1_5: '',
        a2: null,
        a3: [],
        a3_1: '',
        a3_1_1: '',
        a3_2: [],
        a3_4: '',
        a3_5: '',
        a3_6: '',
        a3_7: '',
      },
      errors: {
        error1: {
          value: false,
          text: '確認事項全てにご同意下さい',
        },
        error2: {
          value: false,
          text: '「本サービス(narasu)を知ったきっかけ」を選択してください',
        },
        error3: {
          value: false,
          text: '「その他」の内容をご入力ください',
        },
        error4: {
          value: false,
          text: '「narasuのサービスはいかがでしたでしょうか？」を選択してください',
        },
        error5: {
          value: false,
          text: '「サービス」を選択してください',
        },
        error6: {
          value: false,
          text: '「退会理由」をひとつ以上選択してください',
        },
        error7: {
          value: false,
          text: '「その他」の内容をご入力ください',
        },
        error8: {
          value: false,
          text: '難しい理由を選択してください',
        },
        error9: {
          value: false,
          text: '使いにくかった理由をご入力ください',
        },
        error10: {
          value: false,
          text: '欲しかった機能をご入力ください',
        },
        error11: {
          value: false,
          text: '利用するサービスをご入力ください',
        },
      },
      error_found: false,
      validated_errors: [],
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'isSubscriber']),
    hasDifficult() {
      return this.answers.a3.filter(a => a === '2').length > 0
    },
    hasOtherService() {
      return this.answers.a3.filter(a => a === '1').length > 0
    },
  },
  watch: {
    answers: {
      handler() {
        if (this.error_found) this.validate()
      },
      deep: true,
    },
  },
  methods: {
    onClickWithdrawal() {
      const hasError = this.validate()
      if (hasError) {
        this.error_found = true
        window.scroll(0, 0)
      } else {
        this.withdrawal()
      }
    },
    async withdrawal() {
      const { answers } = this
      const reason = answers.a3.concat()
      if (reason.find(re => re === '1')) {
        reason.unshift(answers.a3_1)
        reason.forEach((item, index) => {
          if (item === '1') {
            reason.splice(index, 1)
          }
        })
      }
      if (reason.find(re => re === '2')) {
        const ans = answers.a3_2.join('、')
        reason.push(`楽曲の登録が難しいから: ${ans}`)
        reason.forEach((item, index) => {
          if (item === '2') {
            reason.splice(index, 1)
          }
        })
      }
      if (reason.find(re => re === '4')) {
        reason.push(answers.a3_4)
        reason.forEach((item, index) => {
          if (item === '4') {
            reason.splice(index, 1)
          }
        })
      }
      if (reason.find(re => re === '5')) {
        reason.push(`使いにくかったから(${answers.a3_5})`)
        reason.forEach((item, index) => {
          if (item === '5') {
            reason.splice(index, 1)
          }
        })
      }
      if (reason.find(re => re === '6')) {
        reason.push(`欲しい機能が不足している(${answers.a3_6})`)
        reason.forEach((item, index) => {
          if (item === '6') {
            reason.splice(index, 1)
          }
        })
      }
      if (reason.find(re => re === '他のサービスを利用するから:その他')) {
        reason.push(`他のサービスを利用するから:その他(${answers.a3_1_1})`)
        reason.forEach((item, index) => {
          if (item === '他のサービスを利用するから:その他') {
            reason.splice(index, 1)
          }
        })
      }
      const enquete = {
        howKnow: answers.a1 === '5' ? answers.a1_5 : answers.a1,
        satisfaction: answers.a2,
        reason,
      }
      try {
        await window.axios.post('/api/client/withdraw', { enquete })
        window.location.href = '/client'
      } catch {
        this.validated_errors.push({ message: '不具合が起きました。時間を空けて再度お試し下さい' })
        window.scroll(0, 0)
      }
    },
    validate() {
      this.validated_errors = []
      this.errors.error1.value = undefined !== this.answers.check_list.find(check => !check.value)
      this.errors.error2.value = this.answers.a1 === null
      this.errors.error3.value = this.answers.a1 === '5' && this.answers.a1_5 === ''
      this.errors.error4.value = this.answers.a2 === null
      this.errors.error5.value = this.answers.a3.includes('1') && this.answers.a3_1 === ''
      this.errors.error6.value = this.answers.a3.length === 0
      this.errors.error7.value = this.answers.a3.includes('4') && this.answers.a3_4 === ''
      this.errors.error8.value = this.answers.a3.includes('2') && this.answers.a3_2.length === 0
      this.errors.error9.value = this.answers.a3.includes('5') && this.answers.a3_5.length === 0
      this.errors.error10.value = this.answers.a3.includes('6') && this.answers.a3_6.length === 0
      this.errors.error11.value = this.answers.a3.includes('1') && this.answers.a3_1 === '他のサービスを利用するから:その他' && this.answers.a3_1_1.length === 0
      let hasError = false
      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key].value) {
          hasError = true
          this.validated_errors.push({ message: this.errors[key].text })
        }
      })
      return hasError
    },
  },
}
</script>
